module.exports = __webpack_public_path__ + "img/Andreas.769fed12.png";